import { render, staticRenderFns } from "./EquipmentWashBasin.vue?vue&type=template&id=fd4bc1cc&scoped=true"
import script from "./EquipmentWashBasin.vue?vue&type=script&lang=ts"
export * from "./EquipmentWashBasin.vue?vue&type=script&lang=ts"
import style0 from "./EquipmentWashBasin.vue?vue&type=style&index=0&id=fd4bc1cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4bc1cc",
  null
  
)

export default component.exports